import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { NgbDate, NgbCalendar, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';

import * as Highcharts from 'highcharts';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ConfirmationDialogService } from '../components/confirmation-dialog/confirmation-dialog.service';
import { DhukanDataService } from '../services/dhukan/dhukan-data.service';
import { LoginDataService } from '../services/dhukan/login-data.service';

@Component({
  selector: 'app-dashboardorganization',
  templateUrl: './dashboardorganization.component.html',
  styleUrls: ['./dashboardorganization.component.css']
})
export class DashboardorganizationComponent implements OnInit {


  isadd: boolean = false;
  isedit: boolean = false;
  isdelete: boolean = false;
  isview: boolean = false;
  isprint: boolean = false;
  isexport: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Dashboard";

  filterColl: any = [];
  filterby: any = "TODAY";

  filterfromdate: any = new Date();
  filtertodate: any = new Date();

  walkincustomer: number = 0;
  newcustomer: number = 0;
  repeatcustomer: number = 0;
  totalcustomer: number = 0;


  successorder: number = 0;
  cancelorder: number = 0;
  openorder: number = 0;
  totalorder: number = 0;
  totalsales: any = 0;

  orderdinetypeColl: any = [];
  orderdinetypedetailsColl: any = [];
  orderpaymodeColl: any = [];
  orderpaymodedetailsColl: any = [];

  salescompanyColl: any = [];
  salesregionColl: any = [];
  salesbranchColl: any = [];

  saleschartColl: any[] = [];

  topsellingproductColl: any = [];
  topsellinggroupColl: any = [];
  expenseColl: any[] = [];
  companyColl: any[] = [];
  cashsummaryColl: any = [];

  shiftclosesummaryColl: any = [];

  openingamt: any = 0;
  expenseamt: any = 0;
  cashsalesamt: any = 0;
  cashsummaryamt: any = 0;


  lastsyncon: any = null;

  //Chart
  view: any[] = [360, 400];
  // options
  gradient: boolean = true;
  showLegend: boolean = false;
  showLabels: boolean = true;
  isDoughnut: boolean = false;
  legendPosition: string = 'below';

  colorScheme = {
    domain: ['#83DA38', '#FFD123', '#46b8da', '#FFAA15']
  };


  view1: any[] = [700, 400];
  // options
  colorScheme1 = {
    // domain: ['#1355b3', '#1355b3', '#1355b3', '#1355b3']
     domain: ['#74CD04', '#74CD04', '#74CD04', '#74CD04']
  };

  hoveredDate: NgbDate | null = null;

  fromDate: NgbDate | null;
  toDate: NgbDate | null;


  ishidedashboard:boolean=false
  _routerLoginSub = Subscription.EMPTY;

  constructor(private appService: DhukanDataService, public router: Router, private route: ActivatedRoute,
    private confirmationDialogService: ConfirmationDialogService, private toastr: ToastrService,
    private loginService: LoginDataService, private datePipe: DatePipe, private calendar: NgbCalendar, public formatter: NgbDateParserFormatter) {

    this.fromDate = calendar.getNext(calendar.getToday(), 'd', -1);
    this.toDate = calendar.getToday();

    if (window.screen.width >= 320 && window.screen.width <= 800) { // 768px portrait
      this.view1 = [300, 400];

    }

    this.fnServiceChanges();
  }

  //User Check
  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckUser()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }
    });

    this._routerLoginSub = this.route.queryParams.subscribe(params => {




      if (params.filterby !== undefined) {
        if (params.filterby !== "CUSTOM") {
          this.filterby = params.filterby
        }

      }




    })



  }



  fnCheckPrivilage() {
    this.isadd = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE');
    this.isedit = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER');
    this.isdelete = this.loginService.fnCheckUserRoleAction(this.formname, 'DELETE');
    this.isview = this.loginService.fnCheckUserRoleAction(this.formname, 'VIEW');
    this.isprint = this.loginService.fnCheckUserRoleAction(this.formname, 'PRINT');
    this.isexport = this.loginService.fnCheckUserRoleAction(this.formname, 'EXPORT');

    this.ishidedashboard=this.loginService.fnCheckUserRoleAction("DisableDashboard", 'VIEW');

    this.isview = true;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }

  fnOnInitForm() {
    if (this.loginService.fnCheckOrganizationUser()) {
      if(Number(this.loginService.fnGetCompanyId())>0){
        this.router.navigate(['/Dashboard']);
      }  
      else{
        this.fngetDasboard();
      this.fnGetFilterType(); 
      }
          
    }
    else{
      this.fngetDasboard();
      this.fnGetFilterType();  
    }   
  }

  ngOnInit() {

    if (this.loginService.fnCheckUser()) {
      this.fnCheckPrivilage();
      if (this.isview) {
        this.isloading = true;
        this.fnOnInitForm();
      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.loginService.fnGetUserRoleList();
    }

  }

  ngOnDestroy(): void {
    if (this._routerLoginSub !== undefined) {
      this._routerLoginSub.unsubscribe();
    }
  }



  fnGetFilterType() {
    this.filterColl = [];
    this.filterColl.push({ 'name': 'Today', 'value': 'TODAY' })
    this.filterColl.push({ 'name': 'Yesterday', 'value': 'YESTERDAY' })
    this.filterColl.push({ 'name': 'This Week', 'value': 'THISWEEK' })
    this.filterColl.push({ 'name': 'This Month', 'value': 'THISMONTH' })
    this.filterColl.push({ 'name': 'Last Week', 'value': 'LASTWEEK' })
    this.filterColl.push({ 'name': 'Last Month', 'value': 'LASTMONTH' })
    this.filterColl.push({ 'name': 'Custom', 'value': 'CUSTOM' })
  }

  fngetDasboard() {

    if (this.showProgress) {
      return;
    }

    if( this.ishidedashboard){
      return
    }
    
    this.fnShowProgress();
    this.filterfromdate = new Date(this.fromDate.year, this.fromDate.month - 1, this.fromDate.day)
    this.filtertodate = new Date(this.toDate.year, this.toDate.month - 1, this.toDate.day)

    var data = {
      'organizationid':this.loginService.fnGetOrganizationId(),
      'companyid': this.loginService.fnGetCompanyId(),
      'filterby': this.filterby,
      'fromdate': this.fnFormatDatetime(this.filterfromdate),
      'todate': this.fnFormatDatetime(this.filtertodate),
      'tokenon': (localStorage.bstokenon === undefined) ? null : this.fnFormatDatetime(JSON.parse(localStorage.bstokenon)),
      'modifiedby': this.loginService.fnGetModUserId()
    }



    this.appService.fnGetDashboardOrganizationAdmin(data)
      .subscribe(
        (res) => {
          this.fnHideProgress();
          if (res.json().status == 200) {
            var _result = res.json().result;

            if (_result.length > 0) {
              var checkresultColl = _result[0];

              if (checkresultColl.length > 0) {
                if (checkresultColl[0].checkresult === "FAILED") {
                  localStorage.removeItem("bstoken");
                  localStorage.removeItem("bscmp");
                  localStorage.removeItem("bstokenon");
                  this.router.navigate(['/Login']);
                  this.toastr.error('Alert', "Session is expiry");
                  return;
                }
              }


              this.companyColl = _result[1];

              if (this.companyColl.length > 0) {
                this.lastsyncon = this.companyColl[0].poslastsyncon

                this.filterfromdate = this.fnConvertDatetime(this.fnFormatDatetime(this.companyColl[0].fromdate));
                this.filtertodate = this.fnConvertDatetime(this.fnFormatDatetime(this.companyColl[0].todate))

              }


              var mainColl = _result[2];


              this.walkincustomer = mainColl[0].walkincustomer;
              this.newcustomer = mainColl[0].newcustomer;
              this.repeatcustomer = mainColl[0].repeatcustomer;
              this.totalcustomer = mainColl[0].totalcustomer;


              this.successorder = mainColl[0].successorder;
              this.cancelorder = mainColl[0].cancelorder;
              this.openorder = mainColl[0].openorder;
              this.totalorder = mainColl[0].totalorder;
              this.totalsales = mainColl[0].totalsales;


              this.orderdinetypeColl = _result[3];
              this.orderdinetypedetailsColl = _result[4];
              
              this.orderpaymodeColl = _result[5];
              this.orderpaymodedetailsColl = _result[6];

              
              
              this.salescompanyColl= _result[7];

              this.salesregionColl= _result[8];
              this.salesbranchColl= _result[9];

              this.saleschartColl = _result[10];

              this.expenseColl = [];
              var expensedata = _result[11];
              for (let abo of expensedata) {
                this.expenseColl.push(abo);
              }

              this.topsellinggroupColl = _result[12];

              
              this.cashsummaryColl = _result[13];

              if (this.cashsummaryColl.length > 0) {
                this.openingamt = this.cashsummaryColl[0].openingamt
                this.expenseamt = this.cashsummaryColl[0].expenseamt
                this.cashsalesamt = this.cashsummaryColl[0].cashsalesamt
                this.cashsummaryamt = this.cashsummaryColl[0].cashsummary
              }


              this.shiftclosesummaryColl= _result[14];

              /*this.topsellingproductColl = _result[6];
              this.salescompanyColl= _result[10];*/
            }

            // //console.log(_result);

            // this.summaryColl = _res[0];

            this.fnSetExpenseChart();
            this.fnSetDailySalesChart();

          }
          else if (res.json().status == 400) {
            console.log(res.json())
            this.toastr.error('Error', res.json().err_field);
          }
        },
        (err) => {
          this.fnHideProgress();
          this.toastr.error('Error', err);
        })
  }

  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date && date.after(this.fromDate)) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }

  isHovered(date: NgbDate) {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return date.equals(this.fromDate) || (this.toDate && date.equals(this.toDate)) || this.isInside(date) || this.isHovered(date);
  }

  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
  }


  onResize(event) {
    this.view1 = [event.target.innerWidth / 1.35, event.target.innerHeight / 2.10];
  }

  fnSetExpenseChart() {

    const data: any[] = [];

    for (let abo of this.expenseColl) {
      data.push({
        name: abo.name,
        y: abo.value,
      });
    }

    const chart = Highcharts.chart('chart-pie', {
      chart: {
        type: 'pie',
      },
      title: {
        text: 'Expense View',
      },
      credits: {
        enabled: false,
      },
      legend: {
        enabled: true,
      },
      tooltip: {
        headerFormat: `<span class="mb-2">Expense: {point.key}</span><br>`,
        pointFormat: '<span>Amount: {point.y}</span>',
        useHTML: true,
      },
      series: [
        {
          name: null,
          innerSize: '0%',
          data,
        },
      ],
    } as any);


  }

  private fnSetDailySalesChart(): void {

    const data: any[] = [];

    if (this.loginService.fnGetCompanyId()>0){
      for (let abo of this.saleschartColl) {
        data.push({
          name: abo.name,
          y: abo.value,
        });
      }
    }
    else{
      for (let abo of this.salescompanyColl) {
        data.push({
          name: abo.companyname,
          y: abo.grandtotal,
        });
      }
    }
   


    const chart = Highcharts.chart(
      'chart-column' as any,
      {
        chart: {
          type: 'column',
        },
        title: {
          text: '',
        },
        credits: {
          enabled: true,
        },
        legend: {
          enabled: false,
        },
        yAxis: {
          min: 0,
          title: undefined,
        },
        xAxis: {
          type: 'category',
        },
        tooltip: {
          headerFormat: `<div>{point.key}</div>`,
          pointFormat: `<div>{series.name}: {point.y}</div>`,
          shared: true,
          useHTML: true,
        },
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: true,
            },
          },
        },
        series: [
          {
            name: 'Amount',
            data,
             color: '#74CD04', 
          },
        ],
      } as any
    );


  }

  private getRandomNumber(min: number, max: number): number {
    return Math.floor(Math.random() * (max - min + 1) + min);
  }




  fnRedirectReportDirect(type) {
    try {

      // let navigationExtras: NavigationExtras = {
      //   queryParams: {
      //     'rtntype': 'Dashboard',
      //     'fromdate': this.fnFormatDatetime(this.filterfromdate),
      //     'todate': this.fnFormatDatetime(this.filtertodate),
      //     'filterby': this.filterby,
      //   }
      // }

      // this.router.navigate(['/' + type], navigationExtras);

    } catch (ex) {
      // this.fnShowErrorMsg(ex);
    }

  }


  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }


  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }
  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }

  fnConvertNgBDate(dt) {
    if (dt) {
      if (dt === null) {
        return null
      }
      else {

        var sdate = new Date(+dt.day, dt.month - 1, +dt.year + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }



}
